import React from "react";
import { useSelector } from "react-redux";
import BasketBody from "../components/BasketBody";
import BasketFooterOverview from "../components/BasketFooterOverview";

import { Spinner } from "components";
import { PageHeaderV2 } from "components/PageHeader";
import AddUserInfoForm from "components/Modals/AddUserInfoForm";

import { useUpdateDeliveryFee } from "hooks";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";

//TODO: requires cleanup

const Basket = () => {
  const { goToSettings, goToLogin, goToStorePage } = useDelivertPickupFn();

  useUpdateDeliveryFee();

  return (
    <div className="store-page-popup relative min-h-app-height">
      <PageHeaderV2
        pageTitle={"Cart"}
        authClick={goToLogin}
        userClick={goToSettings}
        onGoBack={goToStorePage}
        containerStyleProps={{
          style: {
            zIndex: 5,
            position:"sticky",
            top:0,
            backgroundColor:"white",
            width:"98%",
            margin:"0 auto"
          },
        }}
        headerStyleProps={{
          className: "p-5",
        }}
      />
      <div className="relative p-4 flex flex-col gap-4 overflow-y-auto self-stretch ">
        <BasketBody />
       
      </div>
      <AddUserInfoForm />
    <BasketFooterOverview />
    </div>
  );
};

const BasketContainer = () => {
  const { isLoading } = useSelector((state) => state?.loader);
  const { loading } = useSelector((state) => state?.brand);
  if (isLoading || loading) return <Spinner />;
  return <Basket />;
};
export default BasketContainer;
